import { makeAutoObservable } from "mobx";
import * as TeamProvider from '../../services/team/team';
import { TeamAdmResponse, ComboTeamAdmResponse } from '../../services/team/team';
import * as PubSub from '../pubSub';
import { Manager } from "../../core";

export class TeamStoreMobx {
	public teams: TeamAdmResponse[] = [];
    public comboTeams: ComboTeamAdmResponse[] = [];

	constructor() {
		makeAutoObservable(this);
	}

	getTeams = async () => {
		try {
			const { data }: any = await TeamProvider.getTeams();
			this.setTeamsList(data || []);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.teamStore.getTeams', err);
		}
	}

    getComboTeams = async () => {
		try {
			const { data }: any = await TeamProvider.getComboTeams();
			this.setComboTeamsList(data || []);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.teamStore.getComboTeams', err);
		}
	}

    assignTeam = async (comboId: number, cleaningDate: string, teamId: number) => {
        try {
            await TeamProvider.assignTeam(comboId, cleaningDate, teamId);
            // Re-fetch para atualizar a tabela na memória
            await this.getComboTeams();
        } catch (err) {
			throw new Manager.ServiceError('error.teamStore.assignTeam', err);
		}
    }

	setTeamsList = (list: TeamAdmResponse[]) => {
		this.teams = list;
	}

    setComboTeamsList = (list: ComboTeamAdmResponse[]) => {
		this.comboTeams = list;
	}

    getTeamByComboAndDate = (comboId: number, cleaningDate: string): ComboTeamAdmResponse | undefined => {
		return this.comboTeams.find(ct => Number(ct.comboId) === Number(comboId) && ct.cleaningDate === cleaningDate);
	}

	getTeamsByComboId = (comboId: number): ComboTeamAdmResponse[] => {
		return this.comboTeams.filter(ct => Number(ct.comboId) === Number(comboId));
	}
}

let singleton: TeamStoreMobx | null;

export const TeamStore = () => {
	if (!singleton) {
		singleton = new TeamStoreMobx();

		PubSub.subscribe(PubSub.LOGOUT, () => {
			singleton = null;
		});
	}
	return singleton;
};
